import { zodResolver } from '@hookform/resolvers/zod';
import { useForm, UseFormProps } from 'react-hook-form';
import { z } from 'zod';

import { friendlyZodMessage } from '../utils/friendly-zod-message.util';

export const useReactForm = <T extends z.ZodObject, C = unknown>({
  schema,
  ...props
}: {
  schema: T;
} & Omit<UseFormProps<z.output<T>>, 'resolver'>) => {
  return useForm({
    mode: 'onChange',
    ...props,
    // Every form shares one translated fallback so a field without its own message shows product
    // wording instead of Zod's "Invalid input: expected object, received null".
    resolver: zodResolver(schema, { error: friendlyZodMessage }) as unknown as UseFormProps<
      z.output<T>,
      C,
      z.output<T>
    >['resolver'],
  });
};
